import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ordersApi } from '../../api/orders.js';
import { visitsApi } from '../../api/visits.js';

// ─── SVG Icons ───────────────────────────────────────────────────────────────
// Parse YYYY-MM-DD as local date (avoids UTC midnight → wrong day in IST)
const fmtDate = (str) => {
  if (!str) return "—";
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const CalendarIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>;
const ReceiptIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z" /><path d="M14 3v5h5M16 13H8M16 17H8M10 9H8" /></svg>;
const PrinterIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></svg>;
const StoreIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" /><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" /><path d="M2 7h20" /><path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7" /></svg>;
const UserIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
const TruckIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" /></svg>;
const PackageIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21" /><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>;
const PhoneIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
const NoteIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></svg>;
const BikeIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>;
const CarIcon = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H9.3a2 2 0 0 0-1.6.8L5 11l-5.16.86a1 1 0 0 0-.84.99V16h3m10 0a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0m-6 0a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0" /></svg>;
const SearchIcon = () => <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>;
const TrashIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /></svg>;

// ─── Delivery Info Card ──────────────────────────────────────────────────────
function DeliveryInfo({ order }) {
  const method = order.mode_of_delivery || 'unknown';
  const badge = {
    our_delivery: { icon: <BikeIcon />, label: 'Our Delivery Person', color: '#2563eb', bg: '#eff6ff' },
    porter:       { icon: <PackageIcon />, label: 'Porter',              color: '#7c3aed', bg: '#f5f3ff' },
    car:          { icon: <CarIcon />, label: 'Car',                 color: '#0891b2', bg: '#ecfeff' },
    transport:    { icon: <TruckIcon />, label: 'Transport',           color: '#d97706', bg: '#fffbeb' },
  }[method] || { icon: <PackageIcon />, label: method || 'Standard', color: '#64748b', bg: '#f8fafc' };

  const detail = () => {
    if (method === 'our_delivery') return (
      <div>
        {order.delivery_person && <div style={{ fontWeight: 700, fontSize: 14 }}>{order.delivery_person}</div>}
        {order.delivery_person_phone && (
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
            <PhoneIcon /> {order.delivery_person_phone}
          </div>
        )}
      </div>
    );
    if (method === 'porter') return (
      <div>
        <div style={{ fontWeight: 700, fontSize: 14 }}>Porter ID</div>
        <div style={{ fontSize: 13, color: badge.color, fontWeight: 700, marginTop: 2, fontFamily: 'monospace' }}>
          {order.porter_id || order.delivery_details || '—'}
        </div>
      </div>
    );
    if (method === 'car') return (
      <div>
        <div style={{ fontWeight: 700, fontSize: 14 }}>Car Number</div>
        <div style={{ fontSize: 13, color: badge.color, fontWeight: 700, marginTop: 2, fontFamily: 'monospace', letterSpacing: 1 }}>
          {order.car_number || order.delivery_details || '—'}
        </div>
      </div>
    );
    if (method === 'transport') return (
      <div>
        <div style={{ fontWeight: 700, fontSize: 14 }}>Transport ID</div>
        <div style={{ fontSize: 13, color: badge.color, fontWeight: 700, marginTop: 2, fontFamily: 'monospace' }}>
          {order.transport_id || order.delivery_details || '—'}
        </div>
      </div>
    );
    return null;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', borderRadius: 12, background: badge.bg, border: `1.5px solid ${badge.color}22` }}>
      <div style={{ width: 48, height: 48, borderRadius: 12, background: badge.bg, border: `2px solid ${badge.color}44`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0, color: badge.color }}>
        {badge.icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 4 }}>Delivery Method</div>
        <span style={{ display: 'inline-block', background: badge.bg, color: badge.color, border: `1px solid ${badge.color}44`, borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, marginBottom: 6 }}>
          {badge.label}
        </span>
        {detail()}
        <div style={{ marginTop: 8, fontSize: 12, display: 'flex', flexDirection: 'column', gap: 4 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ color: '#64748b', fontWeight: 600, minWidth: 100 }}>Delivery Date:</span>
            <span style={{ fontWeight: 700, color: order.delivery_date ? 'var(--text)' : '#94a3b8' }}>
              {order.delivery_date ? fmtDate(order.delivery_date) : '—'}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ color: '#64748b', fontWeight: 600, minWidth: 100 }}>Dispatch Date:</span>
            <span style={{ fontWeight: 700, color: order.dispatch_date ? 'var(--text)' : '#94a3b8' }}>
              {order.dispatch_date ? fmtDate(order.dispatch_date) : '—'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Section Card Wrapper ────────────────────────────────────────────────────
function Section({ title, icon, children }) {
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-header">
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 14 }}>
          <span style={{ color: 'var(--primary)', display: 'flex', alignItems: 'center' }}>{icon}</span> {title}
        </span>
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
}

// ─── Info Row Component ──────────────────────────────────────────────────────
function InfoRow({ label, value, mono, color }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '8px 0', borderBottom: '1px solid #f8fafc' }}>
      <span style={{ fontSize: 12, color: '#64748b', fontWeight: 500, minWidth: 130 }}>{label}</span>
      <span style={{ fontSize: 13, fontWeight: 600, textAlign: 'right', fontFamily: mono ? 'monospace' : 'inherit', color: color || 'var(--text)' }}>
        {value || '—'}
      </span>
    </div>
  );
}

// ─── Main Component ──────────────────────────────────────────────────────────
export default function OrderDetailPage() {
  const { orderId } = useParams();
  const navigate    = useNavigate();
  const [order,   setOrder]   = useState(null);
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');
  const [cgstRate, setCgstRate] = useState(0);
  const [sgstRate, setSgstRate] = useState(0);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [orderRes, itemsRes] = await Promise.all([
          ordersApi.getById(orderId),
          ordersApi.getItems(orderId),
        ]);
        setOrder(orderRes.data ?? orderRes);
        const rawItems = itemsRes.data ?? itemsRes;
        setItems(Array.isArray(rawItems) ? rawItems : []);
      } catch (err) {
        setError(err.message || 'Failed to load order.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [orderId]);

  useEffect(() => {
    visitsApi.getSystemSettings()
      .then(res => {
        const list = res.data?.data || res.data || [];
        const find = (key) => { const s = list.find(s => s.key === key); return s ? parseFloat(s.value) || 0 : 0; };
        setCgstRate(find('cgst_rate'));
        setSgstRate(find('sgst_rate'));
      })
      .catch(() => {});
  }, []);

  if (loading) return (
    <div className="page-body" style={{ textAlign: 'center', paddingTop: 60 }}>
      <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Loading order…</div>
    </div>
  );

  if (error || !order) return (
    <div className="page-body" style={{ textAlign: 'center', paddingTop: 60 }}>
      <div style={{ color: 'var(--text-muted)', marginBottom: 16, display: 'flex', justifyContent: 'center' }}><SearchIcon /></div>
      <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>Order not found</div>
      <div style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>
        {error || `No order with ID #${orderId}`}
      </div>
      <button className="btn btn-primary" onClick={() => navigate(-1)}>← Go Back</button>
    </div>
  );

  const lead    = order.Lead || order.lead || {};
  const placedByUser = order.Creator || order.creator || order.PlacedBy || order.placedBy || order.User || {};
  const location = (lead.locations || lead.Locations || [])[0] || {};

  const statusMap = { delivered: 'Completed', pending: 'Pending', cancelled: 'Cancelled', hold: 'On Hold' };
  const displayStatus = statusMap[order.status] || order.status || 'Unknown';

  const dateStr = order.created_at
    ? new Date(order.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : '—';
  const timeStr = order.created_at
    ? new Date(order.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })
    : '—';

  // Prefer the DB-computed totals (order.total_amount/cgst_amount/sgst_amount/final_total —
  // the authoritative values recalculateOrderTotal derives server-side from gst_price, the
  // GST-EXCLUSIVE base). Summing unit_price (GST-INCLUSIVE) here and then adding CGST/SGST
  // on top double-counts GST — only fall back to a client-side estimate when those fields
  // are genuinely absent (e.g. an order not yet persisted).
  const clientSubtotal = items.reduce((s, i) => {
    const gstPrice = i.gst_price != null && i.gst_price !== '' ? Number(i.gst_price) : Number(i.unit_price || 0) / 1.18;
    return s + gstPrice * Number(i.quantity || 0);
  }, 0);
  const subtotal      = order.total_amount != null ? Number(order.total_amount) : clientSubtotal;
  const cgstAmount     = order.cgst_amount  != null ? Number(order.cgst_amount)  : Math.round(subtotal * cgstRate) / 100;
  const sgstAmount     = order.sgst_amount  != null ? Number(order.sgst_amount)  : Math.round(subtotal * sgstRate) / 100;
  const totalGstRate   = cgstRate + sgstRate;
  const tax            = cgstAmount + sgstAmount;
  const displayTotal   = order.final_total != null ? Number(order.final_total)
    : totalGstRate > 0 ? subtotal + tax : (Number(order.total_amount) || subtotal);

  const statusColor = displayStatus === 'Completed' ? { color: '#16a34a', bg: '#dcfce7', border: '#bbf7d0' }
                    : displayStatus === 'Pending'   ? { color: '#d97706', bg: '#fef3c7', border: '#fde68a' }
                    :                                 { color: '#dc2626', bg: '#fee2e2', border: '#fecaca' };

  const addressParts = [location.address_line_1, location.city, location.state, location.pincode].filter(Boolean);

  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  const isAdmin = user.role === 'admin';

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete order #${order.id}?`)) return;
    try {
      await ordersApi.remove(order.id);
      navigate('/orders');
    } catch (err) {
      alert(err.message || 'Failed to delete order.');
    }
  };

  return (
    <div className="page-body">

      {/* Top bar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <h1 style={{ fontSize: 18, fontWeight: 800, margin: 0 }}>Order #{order.id}</h1>
            <span style={{ padding: '3px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700, background: statusColor.bg, color: statusColor.color, border: `1px solid ${statusColor.border}` }}>
              {displayStatus}
            </span>
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 3, display: 'flex', alignItems: 'center', gap: 6 }}>
            {order.invoice_number && <><ReceiptIcon /> {order.invoice_number}</>}
          </div>
        </div>
        <button className="btn btn-outline" onClick={() => window.print()}
          style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap', padding: '8px 16px', borderRadius: 10, fontWeight: 600, fontSize: 13, height: 'auto' }}>
          <PrinterIcon /> Print Invoice
        </button>
        {isAdmin && (
          <button className="btn btn-danger" onClick={handleDelete}
            style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap', padding: '8px 16px', borderRadius: 10, fontWeight: 600, fontSize: 13, height: 'auto', background: 'var(--danger)', color: '#fff' }}>
            <TrashIcon /> Delete Order
          </button>
        )}
      </div>

      {/* Invoice banner */}
      <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f4c75 100%)', borderRadius: 16, padding: '20px 24px', marginBottom: 20, color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 11, opacity: .7, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>Invoice Number</div>
          <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: 1, fontFamily: 'monospace' }}>{order.invoice_number || `ORDER-${order.id}`}</div>
          {order.delivery_date && <div style={{ fontSize: 12, opacity: .7, marginTop: 4 }}>Delivery: {fmtDate(order.delivery_date)}</div>}
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, opacity: .7, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>Total Amount</div>
          <div style={{ fontSize: 28, fontWeight: 800 }}>₹{displayTotal.toLocaleString('en-IN')}</div>
          {order.gst_number ? (
            <div style={{ fontSize: 12, opacity: .7, marginTop: 4 }}>GST: {order.gst_number}</div>
          ) : (
            <div style={{ fontSize: 12, opacity: .7, marginTop: 4 }}>{totalGstRate > 0 ? `incl. ${totalGstRate}% GST` : 'excl. GST'}</div>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 16, marginBottom: 0 }}>

        {/* Customer details */}
        <Section title="Customer Detail" icon={<StoreIcon />}>
          {lead.name ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                <div style={{ width: 48, height: 48, borderRadius: 12, background: 'var(--primary)', color: '#fff', fontWeight: 800, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {lead.name.charAt(0)}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{lead.name}</div>
                  {lead.email && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{lead.email}</div>}
                </div>
              </div>
              <InfoRow label="Phone" value={lead.phone ? <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><PhoneIcon /> {lead.phone}</div> : null} />
              {lead.source && <InfoRow label="Source / Zone" value={lead.source} color="var(--primary)" />}
              {addressParts.length > 0 && <InfoRow label="Address" value={addressParts.join(', ')} />}
            </>
          ) : (
            <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>Customer info not available</div>
          )}
        </Section>

        {/* Sales Executive */}
        <Section title="Sales Executive" icon={<UserIcon />}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: 'var(--success)', color: '#fff', fontWeight: 800, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {(order.sales_executive || 'U').charAt(0)}
            </div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{order.sales_executive || '—'}</div>
          </div>
          <InfoRow label="Payment Method" value={order.payment_method} />
          {order.purchase_order_no && <InfoRow label="PO Number" value={order.purchase_order_no} mono />}
          {order.external_order_id && <InfoRow label="External ID" value={order.external_order_id} mono />}
        </Section>
      </div>

      {/* Delivery info */}
      <Section title="Delivery Information" icon={<TruckIcon />}>
        <DeliveryInfo order={order}/>
        {order.delivery_details && (
          <div style={{ marginTop: 12, padding: '10px 14px', borderRadius: 10, background: '#fefce8', border: '1px solid #fde68a', fontSize: 13, color: '#92400e', display: 'flex', alignItems: 'center', gap: 6 }}>
            <NoteIcon /> <span><strong>Note:</strong> {order.delivery_details}</span>
          </div>
        )}
      </Section>

      {/* Order items */}
      <Section title="Order Items" icon={<PackageIcon />}>
        {items.length === 0 ? (
          <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>No items found</div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8, padding: '6px 0', borderBottom: '2px solid var(--border)', marginBottom: 4 }}>
              {['Product', 'Price', 'Qty', 'Total'].map(h => (
                <span key={h} style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.5px' }}>{h}</span>
              ))}
            </div>
            {items.map((item, i) => {
              const product = item.Product || item.product || {};
              const price   = Number(item.unit_price || 0);
              const qty     = Number(item.quantity || 0);
              return (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8, padding: '10px 0', borderBottom: '1px solid #f8fafc', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{product.name || `Item #${item.product_id}`}</div>
                    {product.sku && <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'monospace' }}>{product.sku}</div>}
                    {(item.hsn_code || product.hsn_code) && (
                      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>HSN: <span style={{ fontFamily: 'monospace' }}>{item.hsn_code || product.hsn_code}</span></div>
                    )}
                    {(() => {
                      const activeCustoms = (item.customizations || []).filter(c => c.value !== undefined && c.value !== null && String(c.value).trim() !== "" && String(c.value).trim() !== "—");
                      if (activeCustoms.length === 0) return null;
                      return (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: 4 }}>
                          {activeCustoms.map((c, ci) => {
                            const meta = c.customization || {};
                            const label = meta.label || '';
                            const inputType = meta.input_type || 'text';
                            const unit = meta.unit || '';
                            const value = String(c.value);
                            if (!label) return null;
                            if (inputType === 'media') return (
                              <span key={ci} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '0.68rem', fontWeight: 600, padding: '2px 6px', borderRadius: '4px', background: 'rgba(99,102,241,0.08)', color: '#4338ca', border: '1px solid rgba(99,102,241,0.2)' }}>
                                <img src={value} alt={label} style={{ width: 20, height: 20, objectFit: 'cover', borderRadius: 3 }} onError={e => { e.target.style.display = 'none'; }} />
                                {label}
                              </span>
                            );
                            return (
                              <span key={ci} style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', fontSize: '0.68rem', fontWeight: 600, padding: '2px 6px', borderRadius: '4px', background: 'rgba(99,102,241,0.08)', color: '#4338ca', border: '1px solid rgba(99,102,241,0.2)' }}>
                                {inputType === 'color' && <span style={{ width: 9, height: 9, borderRadius: '50%', background: value, display: 'inline-block', flexShrink: 0 }} />}
                                {label}: {value}{unit ? ` ${unit}` : ''}
                              </span>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                  <span style={{ fontSize: 13 }}>₹{price.toLocaleString('en-IN')}</span>
                  <span style={{ fontSize: 13, fontWeight: 600 }}>×{qty}</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)' }}>₹{(price * qty).toLocaleString('en-IN')}</span>
                </div>
              );
            })}

            <div style={{ marginTop: 12, borderTop: '2px solid var(--border)', paddingTop: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ minWidth: 220 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                    <span style={{ color: 'var(--text-muted)' }}>Subtotal</span>
                    <span style={{ fontWeight: 600 }}>₹{subtotal.toLocaleString('en-IN')}</span>
                  </div>
                  {totalGstRate > 0 ? (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, fontSize: 12 }}>
                        <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>CGST @{cgstRate}%</span>
                        <span style={{ fontWeight: 600 }}>₹{cgstAmount.toLocaleString('en-IN')}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 12 }}>
                        <span style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>SGST @{sgstRate}%</span>
                        <span style={{ fontWeight: 600 }}>₹{sgstAmount.toLocaleString('en-IN')}</span>
                      </div>
                    </>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                      <span style={{ color: 'var(--text-muted)' }}>GST</span>
                      <span style={{ fontWeight: 600 }}>₹0</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 14px', borderRadius: 10, background: 'var(--primary-light)', marginTop: 8 }}>
                    <span style={{ fontWeight: 700, fontSize: 15 }}>Total</span>
                    <span style={{ fontWeight: 800, fontSize: 18, color: 'var(--primary)' }}>₹{displayTotal.toLocaleString('en-IN')}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Section>

      <div style={{ paddingBottom: 20 }} />
    </div>
  );
}
